import { useState, useEffect } from 'react';
import get from 'lodash/get';
import axios from 'axios';

import { INSTAGRAM_API } from 'config';

const useInstagramPosts = () => {
  const [instagramPosts, setInstagramPosts] = useState([]);
  useEffect(() => {
    axios
      .get(INSTAGRAM_API.ENDPOINT, {
        params: {
          access_token: INSTAGRAM_API.ACCESS_TOKEN,
          count: INSTAGRAM_API.POSTS_COUNT,
        },
      })
      .then(res => {
        const posts = get(res, 'data.data', []);
        const media = posts.map(post => ({
          image: post.images,
          carouselMedia: post.carousel_media,
        }));
        setInstagramPosts(media);
      })
      .catch(() => {});
  }, []);

  return instagramPosts;
};

export { useInstagramPosts };
